var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateLogoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 21675",
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 948",
    d: "M10.003 19.557a3.873 3.873 0 00-1.595-1.233 6.178 6.178 0 01-4.061-5.664 29.639 29.639 0 01.156-4.069H15.48c.071.669.123 1.354.153 2.03a5.005 5.005 0 00-3.494 7.5 5.648 5.648 0 01-.545.217 3.749 3.749 0 00-1.589 1.219zm2.433-4a4 4 0 114 4 4 4 0 01-4-4.003zm1.332 0a.453.453 0 00.455.452h1.759v1.756a.452.452 0 10.9 0v-1.756h1.765a.451.451 0 000-.9h-1.765V13.35a.452.452 0 00-.9 0v1.759h-1.759a.453.453 0 00-.455.445zM4.342 7.808a.8.8 0 01-.778-.811v-.153a2.757 2.757 0 01.757-1.954 2.53 2.53 0 011.83-.792.321.321 0 01.049 0h2.645v-.9a1.15 1.15 0 112.3 0v.9h2.647a.327.327 0 01.049 0 2.516 2.516 0 011.825.792 2.75 2.75 0 01.759 1.954v.153a.8.8 0 01-.778.811z"
  })));
}
export default SvgCreateLogoIcon;